import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Button } from "reactstrap";
import { Window } from "@progress/kendo-react-dialogs";
import { Checkbox } from "@progress/kendo-react-inputs";
import ParticipantService from "../../../services/srv-participants/ParticipantService";

export const EventParticipantsInfo = (props) => {
  const { t } = useTranslation();
  const [fields, setFields] = useState(props.fields);
  const onChangeCheckBox = (dataItem) => {
    var selectedField = dataItem.alaN_KODU;
    var newData = [...fields];
    var selectedData = newData.find((a) => a.alaN_KODU === selectedField);
    selectedData.selected = !selectedData.selected;
    setFields(newData);
  };

  const saveParticipantFields = () => {
    var selected = fields.filter((a) => a.selected).map((s) => s.alaN_KODU);
    ParticipantService.addEventParticipantFields({
      alaN_KODLARI: selected,
      etkinliK_TANIM_ID: props.event.etkinliK_TANIM_ID,
    }).then((data) => {
      props.toggleDialog();
      props.getSelectedFields();
    });
  };

  return (
    <Window
      title={props.title}
      onClose={props.toggleDialog}
      stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
      initialHeight={"80vh"}
      initialWidth={"40%"}
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "fixed",
        zIndex: 10000,
      }}
    >
      {fields?.map((field) => {
        return (
          <div>
            <Checkbox
              label={field.alaN_ADI}
              value={field.selected}
              onChange={() => onChangeCheckBox(field)}
            ></Checkbox>
            <br></br>
          </div>
        );
      })}
      <Button
        color="primary"
        type="button"
        size="sm"
        onClick={saveParticipantFields}
      >
        <i className="fa fa-save"></i> {t("save")}
      </Button>
    </Window>
  );
};
